import React from 'react'
import { Bar } from 'react-chartjs-2';
import {Chart as ChartJs} from "chart.js/auto";
import {Card, CardBody} from "react-bootstrap";

function BarChart({chartData}) {
    return (
        <Card>
            <CardBody>
                <Bar data={chartData}  />
            </CardBody>
        </Card>
    )
}

export default BarChart